import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const dialogSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.dialog, {
        base: {
            header: {
                borderColor: '{colors.border}',
                pt: 4,
                px: 6,
            },
            footer: {
                borderColor: '{colors.border}',
            },
            content: {
                zIndex: 'modal',
            },
            positioner: {
                maxH: '100dvh',
                height: '100dvh',
            },
            body: {
                py: 4,
                px: 6,
                fontSize: 'md',
            },
            backdrop: {
                zIndex: 'modal',
            },
            closeTrigger: {
                top: 2,
                colorPalette: 'gray',
            },
        },
        variants: {
            variant: {
                stickyHeader: {
                    header: {
                        position: 'sticky',
                        top: 0,
                        zIndex: 'sticky',
                        borderBottom: '1px solid {colors.border}',
                        bg: 'white',
                    },
                },
            },
        },
    }),
);
